import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../theme";

interface ImageModalProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  alt?: string;
  title?: string;
}

const ImageModal: React.FC<ImageModalProps> = ({
  open,
  onClose,
  imageUrl,
  alt = "Image",
  title: _title,
}) => {
  const theme = useTheme();
  const _colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          maxWidth: "90vw",
          maxHeight: "90vh",
          margin: "auto",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(10px)",
        },
      }}
    >
      <DialogContent
        sx={{
          position: "relative",
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          component="img"
          src={imageUrl}
          alt={alt}
          sx={{
            maxWidth: "100%",
            maxHeight: "90vh",
            minWidth: "600px",
            // width: "auto",
            // height: "auto",
            objectFit: "contain",
            display: "block",
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;
